import { createFileRoute } from '@tanstack/react-router';
import { OperationsOrganizationsPage } from '@/features/operations/operations-organizations-page';
import { operationsGuard } from '@/lib/route-guards';

export const Route = createFileRoute('/operations/organizations/')({
  beforeLoad: operationsGuard,
  component: OperationsOrganizationsIndexRoute,
});

function OperationsOrganizationsIndexRoute() {
  return <OperationsOrganizationsPage />;
}
